import React from 'react';
import OTIcon from '../../../components/tag/OTIcon';
import { OTLink } from '../../../components/tag/OTLink';
import Markdown from '@visma/formula/lib/Markdown';

export const UserInfoRequestCard = ({ form, link }) => {
  const [isOpen, setIsOpen] = React.useState(false);

  const toggle = () => setIsOpen(!isOpen);

  return (
    <div
      className='userinfo-request-collapsible not-aui'
    >
      <button onClick={toggle} className='userinfo-request-collapsible__header'>
        {isOpen ? (
          <OTIcon config={{ type: 'fa', name: 'icon-angle-up', color: 'blue' }} />
        ) : (
          <OTIcon config={{ type: 'fa', name: 'icon-angle-down', color: 'blue' }} />
        )}
        <div>
          <h2>{form.foreignKey}</h2>
        </div>
      </button>
      {isOpen && (
        <div className="userinfo-request-collapsible__content">
          {form.meta?.metaDescription && (
            <Markdown>{form.meta.metaDescription.fi ?? ''}</Markdown>
          )}
          <OTLink link={link} className="ot-button ot-button--light userinfo-request-collapsible__link">
            {form.title}
          </OTLink>
        </div>
      )}
    </div >
  );
};
